/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorSymptomDto } from '../../models/vendor-symptom-dto';

export interface AsControllerGetVendorSymptoms$Params {
  clientWorkspaceId: string;

/**
 * 증상 검색어
 */
  query?: string;
}

export function asControllerGetVendorSymptoms(http: HttpClient, rootUrl: string, params: AsControllerGetVendorSymptoms$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorSymptomDto>>> {
  const rb = new RequestBuilder(rootUrl, asControllerGetVendorSymptoms.PATH, 'get');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorSymptomDto>>;
    })
  );
}

asControllerGetVendorSymptoms.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms';
